export const DATE_FORMATS = {
    medium: "{Mon} {dd}, {yyyy}",
    dateAndTime: "{Mon} {dd}, {HH}:{mm}",
    long: "{Mon} {dd}, {yyyy} {HH}:{mm}",
    mediumSlash: "{dd}/{Mon}/{yyyy}",
}
